import { useCallback, useState } from "react";

export type GateNudgeReason = "email" | "cert";
export const GATE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function useGateNudge() {
  const [nudge, setNudge] = useState<{ reason: GateNudgeReason | null; sequence: number }>({ reason: null, sequence: 0 });
  const pulse = useCallback((reason: GateNudgeReason) => {
    setNudge(previous => ({ reason, sequence: previous.sequence + 1 }));
  }, []);
  const clear = useCallback((reason: GateNudgeReason) => {
    setNudge(previous => previous.reason === reason ? { ...previous, reason: null } : previous);
  }, []);
  return { nudge, pulse, clear };
}
